import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=3015dab9&scoped=true&lang=true&"
import script from "./Search.vue?vue&type=script&lang=js&"
export * from "./Search.vue?vue&type=script&lang=js&"
import style0 from "../../../vab/styles/searchs.css?vue&type=style&index=0&id=3015dab9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3015dab9",
  null
  
)

export default component.exports